import { Injectable } from '@angular/core';
import { ancillaryServiceEndpoints } from 'configs/ancillary-service-endpoints';

@Injectable({ providedIn: 'root' })
export class AncillaryEndpointsService {

  public get accountPermissionsUrl(): string {
    return ancillaryServiceEndpoints.accountPermissionsUrl;
  }

  public get advertiserLogoUrl(): string {
    return ancillaryServiceEndpoints.advertiserLogoUrl;
  }

  public get advertiserLogoFallbackUrl(): string {
    return ancillaryServiceEndpoints.advertiserLogoFallbackUrl;
  }

  public get advertiserTrackingLinkBuilderUrl(): string {
    return ancillaryServiceEndpoints.advertiserTrackingLinkBuilderUrl;
  }

  public get gatekeeperUrl(): string {
    return ancillaryServiceEndpoints.gatekeeperUrl;
  }

  public get alertsUrl(): string {
    return ancillaryServiceEndpoints.alertsUrl;
  }

  public get closeAlertUrl(): string {
    return ancillaryServiceEndpoints.closeAlertUrl;
  }

  public get sessionTokenUrl(): string {
    return ancillaryServiceEndpoints.sessionTokenUrl;
  }

  public get publisherMerchantAlertOptionsUrl(): string {
    return ancillaryServiceEndpoints.publisherMerchantAlertOptionsUrl;
  }

  public get publisherContactSettingsUrl(): string {
    return ancillaryServiceEndpoints.publisherContactSettingsUrl;
  }

}
